var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from 'rxjs/Observable';
var ObjectObservable = /** @class */ (function (_super) {
    __extends(ObjectObservable, _super);
    function ObjectObservable(source) {
        var _this = _super.call(this) || this;
        _this.source = source;
        return _this;
    }
    ObjectObservable.prototype.set = function (value) {
        return Observable.of(undefined);
    };
    ObjectObservable.prototype.update = function (value) {
        return Observable.of(undefined);
    };
    ObjectObservable.prototype.remove = function () {
        return Observable.of(undefined);
    };
    return ObjectObservable;
}(Observable));
export { ObjectObservable };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/object-observable.ts.pre-build-optimizer.js